import request from '../util/http'

// export function queryOrderMessage(data) {
//   return request({
//     url: '/bfe/guarantee/bidingCheck/queryOrderMessage',
//     method: 'get',
//     data
//   })
// }

export function queryOrderMessage(params) {
  return request({
    url: '/zcjf/biz/bfe/guarantee/bidingCheck/queryOrderMessage',
    method: 'get',
    params,
  })
}
export function getFreeTimes(params) {
  return request({
    url: '/zcjf/biz/bfe/guarantee/bidingCheck/getFreeTimes',
    method: 'get',
    params,
  })
}
export function uploadFile(data) {
  return request({
    url: '/zcjf/biz/bfe/guarantee/bidingCheck/uploadFile',
    method: 'post',
    data,
  })
}
export function judgeFreeTimes(data) {
  return request({
    url: '/zcjf/biz/bfe/guarantee/bidingCheck/judgeFreeTimes',
    method: 'post',
    data,
  })
}
export function saveOrder(data) {
  return request({
    url: '/zcjf/biz/bfe/guarantee/bidingCheck/saveOrder',
    method: 'post',
    data,
  })
}
export function selectOrderMessage(data) {
  return request({
    url: '/zcjf/biz/bfe/guarantee/bidingCheck/selectOrderMessage',
    method: 'post',
    data,
  })
}